function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useState } from 'react';
import { Route, Routes as RouterRoutes } from 'react-router-dom';
import { connect, useDispatch, useSelector } from 'react-redux';
import './styles.scss';
import { loadUser as loadCurieUser } from '../../rubriq/actions';
import { loadAccount } from './actions';
import ChangePasswordContainer from './components/ChangePasswordContainer';
import InstitutionInformationContainer from './components/InstitutionInformationContainer';
import LinkedAccounts from './components/LinkedAccounts';
import NavigationContainer from './components/NavigationContainer';
import ProfileContainer from './components/ProfileContainer';
var Routes = function Routes(_ref) {
  var apiRoot = _ref.apiRoot,
    baseUrl = _ref.baseUrl,
    optionalChildRoutes = _ref.children,
    className = _ref.className,
    _ref$displayPassword = _ref.displayPassword,
    displayPassword = _ref$displayPassword === void 0 ? false : _ref$displayPassword,
    foundUsOptions = _ref.foundUsOptions,
    loadAccount = _ref.loadAccount,
    _ref$onUserInformatio = _ref.onUserInformationUpdated,
    onUserInformationUpdated = _ref$onUserInformatio === void 0 ? function () {} : _ref$onUserInformatio,
    userIdentity = _ref.userIdentity;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    formData = _useState2[0],
    setFormData = _useState2[1];
  var handleUserInformationUpdated = function handleUserInformationUpdated(userData) {
    onUserInformationUpdated(userData);
    setFormData(formData ? _objectSpread(_objectSpread({}, formData), userData) : userData);
  };
  var _useSelector = useSelector(function (state) {
      return state;
    }),
    application = _useSelector.application;
  var isAdminForm = application.enableAdminOptions;
  var dispatch = useDispatch();
  useEffect(function () {
    loadAccount(apiRoot, foundUsOptions, userIdentity).then(function (json) {
      if (json.user) {
        handleUserInformationUpdated(json.user);
      }
    });

    // we'll only be showing Curie related info when it's the actual user accessing the profile form
    if (!isAdminForm) {
      dispatch(loadCurieUser());
    }
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: "w-75 mx-auto account-info ".concat(className)
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, userIdentity ? /*#__PURE__*/React.createElement("div", {
    className: "col-md-3"
  }, /*#__PURE__*/React.createElement(NavigationContainer, {
    baseUrl: baseUrl
  })) : null, /*#__PURE__*/React.createElement(RouterRoutes, null, /*#__PURE__*/React.createElement(Route, {
    path: "work-information",
    element: /*#__PURE__*/React.createElement(InstitutionInformationContainer, {
      apiRoot: apiRoot,
      displayPassword: displayPassword,
      formData: formData,
      onUserInformationUpdated: handleUserInformationUpdated,
      userIdentity: userIdentity
    })
  }), /*#__PURE__*/React.createElement(Route, {
    path: "password",
    element: /*#__PURE__*/React.createElement(ChangePasswordContainer, {
      displayPassword: displayPassword,
      onUserInformationUpdated: handleUserInformationUpdated,
      userIdentity: userIdentity
    })
  }), /*#__PURE__*/React.createElement(Route, {
    path: "linked-accounts",
    element: /*#__PURE__*/React.createElement(LinkedAccounts, null)
  }), optionalChildRoutes, /*#__PURE__*/React.createElement(Route, {
    path: "*",
    element: /*#__PURE__*/React.createElement(ProfileContainer, {
      apiRoot: apiRoot,
      displayPassword: displayPassword,
      formData: formData,
      onUserInformationUpdated: handleUserInformationUpdated,
      userIdentity: userIdentity
    })
  }))));
};
var mapStateToProps = function mapStateToProps(_ref2, _ref3) {
  var application = _ref2.application;
  var apiRoot = _ref3.apiRoot,
    userIdentity = _ref3.userIdentity,
    className = _ref3.className,
    _ref3$onUserInformati = _ref3.onUserInformationUpdated,
    onUserInformationUpdated = _ref3$onUserInformati === void 0 ? function () {} : _ref3$onUserInformati;
  return {
    apiRoot: apiRoot,
    className: className,
    foundUsOptions: application.config.foundUsOptions,
    onUserInformationUpdated: onUserInformationUpdated,
    userIdentity: userIdentity
  };
};
var mapDispatchToProps = {
  loadAccount: loadAccount
};
export default connect(mapStateToProps, mapDispatchToProps)(Routes);